const baseRoutes = {
  login: `login`,
  register: `register`,
  schools: `schools`,
  dashboard: `dashboard`,
  reception: `reception`,
  admissionEnquiry: `admission-enquiry`,
  studentManagement: `student-management`,
  schoolManagement: `management`,
  fees_management: `fees_management`,
  task_management: `task-management`,
  ledger_and_account: `ledger-n-account`,
  examControl: `exam-control`,
  academics: `academics`,
  communication: `communication`,
  transportation: `transportation`,
  hr: "hr",
  validateSession: `validate-session`,
  bioMetric: "bio-metric",
  websiteBuilder: "website",
  accessControl: "access-control",
  paymentGateway: "payment-gateway",
  library: `library`,

  // settings routes
  settings: `settings`,

  // help and support routes
  helpAndSupport: `help-and-support`,
  ticket: `ticket`,
};

const appRoutes = {
  login: baseRoutes.login,
  register: baseRoutes.register,
  forgotPassword: "/forgot-password",
  // passwordChange: "/password-change",
  schools: baseRoutes.schools,
  bioMetric: baseRoutes.bioMetric,
  paymentGateway: baseRoutes.paymentGateway,
  userProfile: "user-profile",
  applySchool: "apply-school",
  validateSession: baseRoutes.validateSession,
  //admission-enquiry
  admissionEnquiry: baseRoutes.admissionEnquiry,
  visuals: `${baseRoutes.admissionEnquiry}/visuals`,
  enquiry: `${baseRoutes.admissionEnquiry}/enquiry`,
  formFeeStructure: `${baseRoutes.admissionEnquiry}/formFeeStructure`,
  counselor: `${baseRoutes.admissionEnquiry}/counselor`,
  previousSchool: `${baseRoutes.admissionEnquiry}/previousSchool`,
  createNewStudent: `${baseRoutes.admissionEnquiry}/createNewStudent`,

  // dashboard
  dashboard: baseRoutes.dashboard,
  schoolDashboard: `${baseRoutes.dashboard}/school`,
  collegeDashboard: `${baseRoutes.dashboard}/college`,
  coachingDashboard: `${baseRoutes.dashboard}/coaching`,
  groupOfInstitutesDashboard: `${baseRoutes.dashboard}/group-of-institutes`,

  // students
  studentManagement: baseRoutes.studentManagement,
  admissionApproval: `${baseRoutes.studentManagement}/admission-approval`,
  certificate: `${baseRoutes.studentManagement}/certificate`,
  students: `${baseRoutes.studentManagement}/students`,
  studentReport: `${baseRoutes.studentManagement}/student-report`,
  studentSR: `${baseRoutes.studentManagement}/student-sr`,
  bulkEdit: `${baseRoutes.studentManagement}/bulkEdit`,
  promotionAndMigration: `${baseRoutes.studentManagement}/promotionAndMigration`,
  create_student: `${baseRoutes.studentManagement}/students/create-student`,
  student_profile: `${baseRoutes.studentManagement}/students/student-profile`,
  alumni: `${baseRoutes.studentManagement}/alumni`,
  idCard: `${baseRoutes.studentManagement}/idCard`,
  existStudent: `${baseRoutes.studentManagement}/existStudent`,
  edit_promotion_student_details: `${baseRoutes.studentManagement}/promotionAndMigration/edit-details`,
  migrate: `${baseRoutes.studentManagement}/promotionAndMigration/migrate`,
  editMigrate: `${baseRoutes.studentManagement}/promotionAndMigration/edit-migration`,
  edit_admission_approval_details: `${baseRoutes.studentManagement}/admission-approval/edit-details/:requestDocId`,
  studentVisuals: `${baseRoutes.studentManagement}/visuals`,

  //reception
  reception: baseRoutes.reception,
  complaints: `${baseRoutes.reception}/complaints`,
  visitorControl: `${baseRoutes.reception}/visitor-control`,
  staffAttendance: `${baseRoutes.reception}/staff-attendance`,
  admission_enquiry: `${baseRoutes.reception}/admission-enquiry`,

  // school management
  schoolManagement: baseRoutes.schoolManagement,
  sessionSettings: `${baseRoutes.schoolManagement}/session-settings`,
  departments: `${baseRoutes.schoolManagement}/departments`,
  subjects: `${baseRoutes.schoolManagement}/subjects`,
  classes: `${baseRoutes.schoolManagement}/classes`,
  // invitationCode: `${baseRoutes.schoolManagement}/invitation-code`,
  billsUsage: `${baseRoutes.schoolManagement}/bills-usage`,
  storage: `${baseRoutes.schoolManagement}/storage`,

  // access control
  accessControl: baseRoutes.accessControl,
  permission: `${baseRoutes.accessControl}/permission`,
  authorizedPerson: `${baseRoutes.accessControl}/authorized-person`,
  sessionOrders: `${baseRoutes.accessControl}/session-orders`,

  //fees
  fees_management: baseRoutes.fees_management,
  fees: `${baseRoutes.fees_management}/fees-structure`,
  collectFee: `${baseRoutes.fees_management}/collect-fee`,
  fees_collection: `${baseRoutes.fees_management}/fees_collection`,
  fees_collection2: `${baseRoutes.fees_management}/new-fee-collection`,
  fees_report: `${baseRoutes.fees_management}/fees_report`,
  fees_invoice: `${baseRoutes.fees_management}/fees_invoice`,
  fees_discount: `${baseRoutes.fees_management}/fees_discount`,
  arrear: `${baseRoutes.fees_management}/arrear`,
  invoice: `${baseRoutes.fees_management}/invoice`,
  sessionOrderInvoice: `${baseRoutes.fees_management}/session-order-invoice`,
  NewInvoice: `${baseRoutes.fees_management}/new-invoice`,
  arrearInvoice: `${baseRoutes.fees_management}/arrear-invoice`,
  adhoc: `${baseRoutes.fees_management}/adhoc`,

  // task management
  task_management: baseRoutes.task_management,
  tasks: `${baseRoutes.task_management}/tasks`,
  taskReport: `${baseRoutes.task_management}/task-report`,

  // Ledger and Account
  ledger_and_account: baseRoutes.ledger_and_account,
  collections: `${baseRoutes.ledger_and_account}/collections`,
  expenses: `${baseRoutes.ledger_and_account}/expenses`,
  ledger_repport: `${baseRoutes.ledger_and_account}/ledger-report`,
  collectionSubHeads: `${baseRoutes.ledger_and_account}/ledger-report/sub-heads/c/:id`,
  expenseSubHeads: `${baseRoutes.ledger_and_account}/ledger-report/sub-heads/e/:id`,
  firms: `${baseRoutes.ledger_and_account}/firms`,
  firmProfile: `${baseRoutes.ledger_and_account}/firm/profile`,
  books: `${baseRoutes.ledger_and_account}/books`,
  paySlip: `${baseRoutes.ledger_and_account}/books/pay-slip`,

  // collectionInvoice: `${baseRoutes.ledger_and_account}/collection/invoice`,
  firmInvoice: `${baseRoutes.ledger_and_account}/firm-invoice`,

  //exam-control
  examControl: baseRoutes.examControl,
  testsAndExams: `${baseRoutes.examControl}/tests-and-exams`,
  reportCard: `${baseRoutes.examControl}/report-card`,
  admitCard: `${baseRoutes.examControl}/admit-card`,
  printAdmitCard: `${baseRoutes.examControl}/admit-card/printAdmitCard`,

  //academics
  academics: baseRoutes.academics,
  homework: `${baseRoutes.academics}/homework`,
  attendanceAndLeave: `${baseRoutes.academics}/attendance-and-leave`,
  timeTable: `${baseRoutes.academics}/timetable`,
  syllabus: `${baseRoutes.academics}/syllabus`,
  subject_details: `${baseRoutes.academics}/syllabus/subject-details`,
  academicCalendar: `${baseRoutes.academics}/academic-calendar`,

  // transportation
  transport: baseRoutes.transportation,
  transportDetail: `${baseRoutes.transportation}/transport-detail`,
  routeDetail: `${baseRoutes.transportation}/route-detail`,
  feeStructure: `${baseRoutes.transportation}/fee-structure`,
  transportStudent: `${baseRoutes.transportation}/transport-student`,
  updateTransportDetail: `${baseRoutes.transportation}/updateTransportDetail`,

  //communication
  communication: baseRoutes.communication,
  noticeBoard: `${baseRoutes.communication}/notice-board`,
  textSms: `${baseRoutes.communication}/text-sms`,
  whatsApp: `${baseRoutes.communication}/whatsapp`,
  vlwhatsapp: `${baseRoutes.communication}/vlwhatsapp`,

  // Human Resources
  hr: baseRoutes.hr,
  staffManagement: `${baseRoutes.hr}/staff-management`,
  joiningApproval: `${baseRoutes.hr}/joining-approval`,
  staffProfile: `${baseRoutes.hr}/staff-management/staff-profile`,
  newRegistration: `${baseRoutes.hr}/staff-management/newRegistration`,
  staffLeave: `${baseRoutes.hr}/staff-leave`,
  payroll: `${baseRoutes.hr}/payroll`,
  createPayroll: `${baseRoutes.hr}/payroll/create`,
  printSlip: `${baseRoutes.hr}/payroll/print-slip`,

  //About School
  aboutSchool: `${baseRoutes.schools}/about-school`,
  schoolProfile: `${baseRoutes.schools}/school-profile`,

  // bio-metric
  punchLog: `${baseRoutes.bioMetric}/punch-log`,
  deviceDetail: `${baseRoutes.bioMetric}/device-detail`,
  userDetail: `${baseRoutes.bioMetric}/user-detail`,

  // website-builder
  websiteBuilder: baseRoutes.websiteBuilder,
  homePage: `${baseRoutes.websiteBuilder}/home`,
  galleryAndLinks: `${baseRoutes.websiteBuilder}/gallery-and-links`,
  aboutUs: `${baseRoutes.websiteBuilder}/about-us`,
  academic: `${baseRoutes.websiteBuilder}/academic/`,
  achievementsHub: `${baseRoutes.websiteBuilder}/achievements-hub`,

  orders: `${baseRoutes.paymentGateway}/orders`,
  configuration: `${baseRoutes.paymentGateway}/configuration`,
  razorpayCallback: `${baseRoutes.paymentGateway}/razorpay-callback`,

  // library
  library: baseRoutes.library,

  // settings
  settings: baseRoutes.settings,

  // Ekalsutra Policy
  privacyPolicy: "/schools/privacy-policy",
  termsAndConditions: "/schools/terms-and-conditions",
  refundPolicy: "/schools/refund-policy",

  // helpAndSupport
  helpAndSupport: `${baseRoutes.helpAndSupport}`,
  ticketDetails: `${baseRoutes.helpAndSupport}/ticket/:ticketId`,

  // complaints
  complaintDetails: `${baseRoutes.reception}/complaint/:complaintId`,
};

export default appRoutes;
